import { ColorProps, FlexProps } from '@chakra-ui/react';
import { ReactNode } from 'react';
import { Flex } from '../../../atoms';
import { MoneyTemplateCardBody } from './components/money-template-card-body';

export type MoneyTemplateStyleVariantType =
  | 'default'
  | 'fulfilled'
  | 'warning'
  | 'selected';

type VariantObjectReturnType = {
  backgroundColor: ColorProps['color'];
  borderColor: ColorProps['color'];
};

type Props = {
  variant?: MoneyTemplateStyleVariantType;
  children?: ReactNode;
} & FlexProps;

const variantStyle: {
  [type in MoneyTemplateStyleVariantType]: VariantObjectReturnType;
} = {
  default: {
    backgroundColor: 'inherit',
    borderColor: 'palette_gray.10'
  },
  selected: {
    backgroundColor: 'palette_blue.5',
    borderColor: 'palette_blue.100'
  },
  fulfilled: {
    backgroundColor: 'palette_gray.0',
    borderColor: 'palette_gray.10'
  },
  warning: {
    backgroundColor: 'palette_alert.0',
    borderColor: 'palette_alert.100'
  }
};

export function MoneyTemplateCard({
  variant,
  children,
  ...rest
}: Props): JSX.Element {
  const currentVariantStyle = variantStyle[variant ?? 'default'];

  return (
    <Flex
      position="relative"
      flexDirection="column"
      justifyContent="center"
      gap="space_unit.x2"
      overflow="hidden"
      borderWidth="1px"
      borderRadius="radii.x1"
      borderColor={currentVariantStyle.borderColor}
      backgroundColor={currentVariantStyle.backgroundColor}
      {...rest}
    >
      {children}
    </Flex>
  );
}

MoneyTemplateCard.Body = MoneyTemplateCardBody;
